import baseApi from '../../base.api'
import { actions as authActions } from '../../../reducers/auth.reducer'

export const onUpdateUserQueryStarted = async (args, { queryFulfilled, dispatch, getState }) => {
    const filterVariants = [{ organizationOnly: true }, { organizationOnly: false }]

    const updateUserQueryData = filterVariant => {
        dispatch(
            baseApi.util.updateQueryData('fetchUsers', filterVariant, draft => {
                const userIndex = draft?.findIndex(user => user.id === args.id)
                if (userIndex !== -1) draft[userIndex] = { ...draft[userIndex], ...args }
            }),
        )
    }

    try {
        await queryFulfilled
        filterVariants.forEach(filter => updateUserQueryData(filter))

        // Check if the updated user is the current user
        const currentUserId = getState().auth.user?.id
        if (currentUserId && currentUserId === args.id) {
            // Trigger fetchCurrentUser to refresh the current user data in auth store
            dispatch(authActions.fetchCurrentUser())
        }
    } catch (error) {
        console.error('Failed to update user query data:', error)
    }
}
